<template>
  <div id="app">
    <router-view/>
    <announcement :show="announcementDialogData.show" :data="announcementDialogData.data"></announcement>
  </div>
</template>
<script>
import _ from 'lodash'

  export default {
      data() {
        return {
            announcementDialogData: {
                show: false,
                data: {}
            },
        }
    },
      async created()
    {
      // 取得公告資訊
      const currentTime = this.$moment().tz('Asia/Taipei').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      await this.$store.dispatch("getAnnouncement", {dateStart: currentTime, dateEnd: currentTime})
      const announcementList = this.$store.state.announcementList
      if(announcementList) {
        if(announcementList['content'] && _.isArray(announcementList['content'])) {
          if(announcementList['content'].length > 0) {
            this.announcementDialogData.data = announcementList['content']
            // 顯示公告
            this.announcementDialogData.show = true
          }
        }
      }
    },
  }
</script>

